// import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
// import "react-quill/dist/quill.snow.css";
// import "./pages/pages.css";
// import LoginPage from "./pages/CommonPages/LoginPage";
// import UserSetPasswordPage from "./pages/CommonPages/UserSetPasswordPage";
// import ResetPasswordPage from "src/pages/CommonPages/ResetPasswordPage/ResetPasswordPage";
// import ForgotPassword from "src/pages/CommonPages/ForgotPassword/ForgotPassword";
// import ZoomAuthorizationCheckPage from "./pages/CommonPages/ZoomAuthorizationCheckPage";
// import NotFoundPage from "./pages/CommonPages/NotFoundPage";
// import "src/Assets/styles/common.scss";
// import i18n from "i18next";
// import { initReactI18next } from "react-i18next";
// import LanguageDetector from "i18next-browser-languagedetector";
// import HttpApi from "i18next-http-backend";
// import AdminRoutes from "./routes/AdminRoutes";
// import AuthorRoutes from "./routes/AuthorRoutes";
// import MentorRoutes from "./routes/MentorRoutes";
// import LearnerRoutes from "./routes/LearnerRoutes";

// //FIXME:move to seperate file
// i18n
//   .use(initReactI18next)
//   .use(LanguageDetector)
//   .use(HttpApi)
//   .init({
//     supportedLngs: ["en", "hi", "ar", "es"],
//     fallbackLng: "en",
//     detection: {
//       order: ["cookie", "htmlTag", "localStorage", "path", "subdomain"],
//       caches: ["cookie"],
//     },
//     backend: { loadPath: "/assets/locales/{{lng}}/translation.json" },
//     react: { useSuspense: false },
//   });

// function App() {
//   return (
//     <BrowserRouter>
//       <Switch>
//         <Route exact path="/">
//           <Redirect to="/login" />
//         </Route>
//         <Route exact path="/login">
//           <LoginPage />
//         </Route>
//         <Route exact path="/welcome">
//           <UserSetPasswordPage />
//         </Route>
//         <Route exact path="/forgot-password">
//           <ForgotPassword />
//         </Route>
//         <Route exact path="/reset-password">
//           <ResetPasswordPage />
//         </Route>
//         <Route exact path="/authorization">
//           <ZoomAuthorizationCheckPage />
//         </Route>
//         <Route path="/admin">
//           <AdminRoutes />
//         </Route>
//         <Route path="/author">
//           <AuthorRoutes />
//         </Route>
//         <Route path="/mentor">
//           <MentorRoutes />
//         </Route>
//         <Route path="/">
//           <LearnerRoutes />
//         </Route>
//         <Route exact path="">
//           <NotFoundPage />
//         </Route>
//       </Switch>
//     </BrowserRouter>
//   );
// }

// export default App;

// import HomePage from "./pages/LearnerPages/Homepage/HomePage";
// import CourseDescriptionPage from "./pages/LearnerPages/CourseDescriptionPage/CourseDescriptionPage";
// import CourseListingPage from "./pages/LearnerPages/CourseListingPage";
// import LearnerProfilePage from "./pages/LearnerPages/LearnerProfilePage";
// import EditLearnerProfilePage from "./pages/LearnerPages/EditLearnerProfilePage";
// import CourseContentPage from "./pages/LearnerPages/CourseContentPage/CourseContentPage";
// import PathwayDescriptionPage from "./pages/LearnerPages/PathwayDescriptionPage/PathwayDescriptionPage";
// import Mylearning from "./pages/LearnerPages/MylearningPage";
// import ViewAttachmentPage from "./pages/Admin-Author-Mentor-Pages/MentorPages/ViewAttachmentPage";
// import LearnerSession from "src/pages/LearnerPages/LearnerSessionPage/LearnerSessionPage";
// import BookSessionPage from "src/pages/LearnerPages/BookSessionPage";
// import UpcommingSessionsPage from "src/pages/LearnerPages/UpcommingSessionsPage/UpcommingSessionsPage";
// import SearchResultsPage from "./pages/LearnerPages/SearchResultsPage/SearchResultsPage";
// import NotificationsPage from "./pages/LearnerPages/NotificationsPage";
// import QuizPage from "./pages/LearnerPages/QuizPage";
// import AdminRoutes from "./routes/AdminRoutes";

import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import "react-quill/dist/quill.snow.css";
import "./pages/pages.css";
import LoginPage from "./pages/CommonPages/LoginPage";

import PrivateRoute from "./components/Common/authorization/PrivateRoute";
import UsersListPage from "./pages/Admin-Author-Mentor-Pages/AdminPages/UsersListPage";
import AdminCoursesTablePage from "./pages/Admin-Author-Mentor-Pages/AdminPages/AdminCoursesTablePage";
import CreateCoursePage from "./pages/CreateCoursePage/CreateCoursePage";
import AuthorCoursesTablePage from "./pages/Admin-Author-Mentor-Pages/AuthorPages/AuthorCoursesTablePage";
import EditCoursePage from "./pages/EditCoursePage/EditCoursePage";
import UserFormPage from "./pages/Admin-Author-Mentor-Pages/AdminPages/UserFormPage/UserFormPage";
import UserSetPasswordPage from "./pages/CommonPages/UserSetPasswordPage";
import ViewCoursePage from "./pages/ViewCoursePage/ViewCoursePage";
import ProfilePage from "./pages/Admin-Author-Mentor-Pages/CommonPages/ProfilePage";

import View from "./pages/Admin-Author-Mentor-Pages/CommonPages/View";
import PathwaysPage from "./pages/Admin-Author-Mentor-Pages/AdminPages/PathwaysPage";
import CreatePathwayPage from "./pages/Admin-Author-Mentor-Pages/AdminPages/CreatePathwayPage/CreatePathwayPage";
import EditPathwayPage from "./pages/Admin-Author-Mentor-Pages/AdminPages/EditPathWayPage";
import ViewPathWayPage from "./pages/Admin-Author-Mentor-Pages/AdminPages/ViewPathWayPage";

import MentorCoursesTablePage from "./pages/Admin-Author-Mentor-Pages/MentorPages/MentorCoursesTablePage";
import ViewCourseMentorPage from "./pages/Admin-Author-Mentor-Pages/MentorPages/ViewCourseMentorPage";
import DashBoardPage from "./pages/Admin-Author-Mentor-Pages/AdminPages/DashBoardPage";
import SessionsPage from "./pages/Admin-Author-Mentor-Pages/MentorPages/SessionsPage/SessionsPage";
import CreateSessionPage from "./pages/Admin-Author-Mentor-Pages/MentorPages/CreateSessionPage";
import ZoomSession from "src/pages/Admin-Author-Mentor-Pages/MentorPages/ZoomSession";
import EditSessionPage from "src/pages/Admin-Author-Mentor-Pages/MentorPages/EditSessionPage";
import { Role } from "./interfaces/User";
import ResetPasswordPage from "src/pages/CommonPages/ResetPasswordPage/ResetPasswordPage";
import ForgotPassword from "src/pages/CommonPages/ForgotPassword/ForgotPassword";

import SessionRequestsPage from "src/pages/Admin-Author-Mentor-Pages/MentorPages/SessionRequestsPage";
import ZoomAuthorizationCheckPage from "./pages/CommonPages/ZoomAuthorizationCheckPage";
import NotFoundPage from "./pages/CommonPages/NotFoundPage";

import "src/Assets/styles/common.scss";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import CheckAuthentication from "./components/Common/authorization/CheckAuthentication";
import TranslationPage from "./pages/Admin-Author-Mentor-Pages/CommonPages/TranslationPage";
import TranslationDashBoardLayout from "./components/AdminAuthorMentorComponents/Common/Translation/TranslationDashBoardLayout";
import CreateCertificate from "./pages/Admin-Author-Mentor-Pages/CommonPages/CreateCertificatePage";
import CertificatesPage from "./pages/Admin-Author-Mentor-Pages/CommonPages/CertificatesPage";
import CommingSoonPage from "src/pages/CommonPages/CommingSoonPage";
import WebWatchFormPage from "./pages/Admin-Author-Mentor-Pages/CommonPages/WebWatchFormPage";
import InfographiaFormPage from "./pages/Admin-Author-Mentor-Pages/CommonPages/InfographiaFormPage";
import WebwatchAndInfographiaTable from "./components/AdminAuthorMentorComponents/Common/Tables/WebWatchAndInfographia/WebwatchAndInfographia";
import Pilot from "./pages/Pilot";
import CreateByte from "./components/AdminAuthorMentorComponents/Common/Bytes/CreateByte";
import BytesTable from "./components/AdminAuthorMentorComponents/Common/Bytes/BytesTable";
import CreateCoupon from "./components/AdminAuthorMentorComponents/Common/Coupon/CreateCoupon";
import CouponsTable from "./components/AdminAuthorMentorComponents/Common/Coupon/CouponsTable";
import DrmPoc from "./pages/DrmPoc";
import CourseAnalytics from "./pages/Admin-Author-Mentor-Pages/AdminPages/CourseAnalytics";
import Help from "./pages/Help";
import CourseCategoriesPage from "./pages/Admin-Author-Mentor-Pages/AdminPages/CourseCategoriesPage";
import Refunds from "./pages/Refunds/Refunds";
import CouponAnalytics from "./pages/Admin-Author-Mentor-Pages/AdminPages/CouponAnalytics";
import ByteAnalytics from "./pages/Admin-Author-Mentor-Pages/AdminPages/ByteAnalytics";
import CourseDescriptionPage from "./pages/LearnerPages/CourseDescriptionPage/CourseDescriptionPage";
import CourseContentPage from "./pages/LearnerPages/CourseContentPage/CourseContentPage";
import "./App.css";
import MaintenancePage from "./pages/Maintenance";

//FIXME:move to seperate file
i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    supportedLngs: ["en", "hi", "ar", "es", "zho"],
    fallbackLng: "en",
    detection: {
      order: ["cookie", "htmlTag", "localStorage", "path", "subdomain"],
      caches: ["cookie"],
    },
    backend: { loadPath: "/assets/locales/{{lng}}/translation.json" },
    react: { useSuspense: false },
  });

function App() {
  return (
    <>
      <BrowserRouter>
        <Switch>
          <Route path="*" component={MaintenancePage}/>
          {/* <Route exact path="/pilot">
            <Pilot />
          </Route>

          // ========= Common Routes =============== 
          <Route exact path="/">
            <Redirect to="/login" />
          </Route>
          <Route exact path="/login">
            <LoginPage />
          </Route>
          <Route exact path="/welcome">
            <UserSetPasswordPage />
          </Route>
          <Route exact path="/forgot-password">
            <ForgotPassword />
          </Route>
          <Route exact path="/reset-password">
            <ResetPasswordPage />
          </Route>
          <Route exact path="/authorization">
            <ZoomAuthorizationCheckPage />
          </Route>

          // ========= Admin Routes ===============

          // <AdminRoutes />

          <PrivateRoute exact path="/help" role={Role.ADMIN}>
            <Help />
          </PrivateRoute>

          <PrivateRoute exact path="/admin/dashboard" role={Role.ADMIN}>
            <DashBoardPage />
          </PrivateRoute>
          <PrivateRoute exact path="/admin/courses" role={Role.ADMIN}>
            <AdminCoursesTablePage />
          </PrivateRoute>
          <PrivateRoute
            exact
            path="/admin/courses/analytics/:courseId"
            role={Role.ADMIN}
          >
            <CourseAnalytics />
          </PrivateRoute>
          <PrivateRoute
            exact
            path="/admin/coupons/analytics/:couponId"
            role={Role.ADMIN}
          >
            <CouponAnalytics />
          </PrivateRoute>
          <PrivateRoute
            exact
            path="/admin/bytes/analytics/:byteId"
            role={Role.ADMIN}
          >
            <ByteAnalytics />
          </PrivateRoute>
          <PrivateRoute exact path="/admin/create-byte" role={Role.ADMIN}>
            <CreateByte />
          </PrivateRoute>
          <PrivateRoute exact path="/admin/edit-byte/:byteId" role={Role.ADMIN}>
            <CreateByte />
          </PrivateRoute>
          <PrivateRoute exact path="/admin/bytes" role={Role.ADMIN}>
            <BytesTable />
          </PrivateRoute>

          <PrivateRoute exact path="/admin/create-coupon" role={Role.ADMIN}>
            <CreateCoupon />
          </PrivateRoute>

          <PrivateRoute
            exact
            path="/admin/edit-coupon/:discountCodeId"
            role={Role.ADMIN}
          >
            <CreateCoupon />
          </PrivateRoute>

          <PrivateRoute exact path="/admin/coupons" role={Role.ADMIN}>
            <CouponsTable />
          </PrivateRoute>

          <PrivateRoute exact path="/admin/refunds" role={Role.ADMIN}>
            <Refunds />
          </PrivateRoute>

          <PrivateRoute exact path="/admin/course-categories" role={Role.ADMIN}>
            <CourseCategoriesPage />
          </PrivateRoute>

          <PrivateRoute exact path="/admin/create-course" role={Role.ADMIN}>
            <CreateCoursePage />
          </PrivateRoute>
          <PrivateRoute exact path="/admin/users" role={Role.ADMIN}>
            <UsersListPage />
          </PrivateRoute>
          <PrivateRoute exact path="/admin/create-user" role={Role.ADMIN}>
            <UserFormPage edit={false} />
          </PrivateRoute>
          <PrivateRoute exact path="/admin/:userId/edit-user" role={Role.ADMIN}>
            <UserFormPage edit={true} />
          </PrivateRoute>
          <PrivateRoute exact path="/admin/:courseId/edit" role={Role.ADMIN}>
            <CreateCoursePage />
          </PrivateRoute>
          <PrivateRoute
            exact
            path="/course-description/:slug"
            role={Role.ADMIN}
          >
            <CourseDescriptionPage />
          </PrivateRoute>
          <PrivateRoute exact path="/course-content/:slug" role={Role.ADMIN}>
            <CourseContentPage />
          </PrivateRoute>
          <PrivateRoute exact path="/admin/draft" role={Role.ADMIN}>
            <CreateCoursePage />
          </PrivateRoute>
          <PrivateRoute
            exact
            path="/admin/view-course/:courseId"
            role={Role.ADMIN}
          >
            <ViewCoursePage />
          </PrivateRoute>
          <PrivateRoute exact path="/admin/view/:course_id" role={Role.ADMIN}>
            <View />
          </PrivateRoute>
          <PrivateRoute exact path="/admin/profile" role={Role.ADMIN}>
            <ProfilePage />
          </PrivateRoute>

          <PrivateRoute exact path="/admin/pathways" role={Role.ADMIN}>
            <PathwaysPage />
          </PrivateRoute>
          <PrivateRoute exact path="/admin/create-pathway" role={Role.ADMIN}>
            <CreatePathwayPage />
          </PrivateRoute>
          <PrivateRoute
            exact
            path="/admin/:pathwayId/pathway/edit"
            role={Role.ADMIN}
          >
            <EditPathwayPage />
          </PrivateRoute>
          <PrivateRoute
            exact
            path="/admin/:pathwayId/pathway/view"
            role={Role.ADMIN}
          >
            <ViewPathWayPage />
          </PrivateRoute>
          <PrivateRoute exact path="/admin/view/:course_id" role={Role.ADMIN}>
            <View />
          </PrivateRoute>
          <PrivateRoute
            exact
            path="/admin/certificates/create"
            role={Role.ADMIN}
          >
            <CreateCertificate />
          </PrivateRoute>
          <PrivateRoute exact path="/admin/certificates" role={Role.ADMIN}>
            <CertificatesPage />
          </PrivateRoute>
          <PrivateRoute exact path="/admin/add-webwatch" role={Role.ADMIN}>
            <WebWatchFormPage />
          </PrivateRoute>
          <PrivateRoute exact path="/admin/add-infographia" role={Role.ADMIN}>
            <InfographiaFormPage />
          </PrivateRoute>
          <PrivateRoute
            exact
            path="/admin/getWebwatchAndInfographia"
            role={Role.ADMIN}
          >
            <WebwatchAndInfographiaTable />
          </PrivateRoute>
          <CheckAuthentication
            exact
            path="/admin/translation/:courseId/:translationString"
          >
            <TranslationDashBoardLayout>
              <TranslationPage />
            </TranslationDashBoardLayout>
          </CheckAuthentication>
          // ========= Author Routes =============== 
          <PrivateRoute role={Role.AUTHOR} exact path="/author/create-course">
            <CreateCoursePage />
          </PrivateRoute>
          <PrivateRoute role={Role.AUTHOR} exact path="/author">
            <AuthorCoursesTablePage />
          </PrivateRoute>
          <PrivateRoute role={Role.AUTHOR} exact path="/author/:courseId/edit">
            <EditCoursePage />
          </PrivateRoute>
          <PrivateRoute
            role={Role.AUTHOR}
            exact
            path="/author/view-course/:courseId"
          >
            <ViewCoursePage />
          </PrivateRoute>
          <PrivateRoute role={Role.AUTHOR} exact path="/author/view/:course_id">
            <View />
          </PrivateRoute>
          <PrivateRoute role={Role.AUTHOR} exact path="/author/profile">
            <ProfilePage />
          </PrivateRoute>

          // ========= Mentor Routes ===============
          <PrivateRoute exact path="/mentor/courses" role={Role.MENTOR}>
            <MentorCoursesTablePage />
          </PrivateRoute>
          <PrivateRoute
            exact
            path="/mentor/courses/view-course/:course_id"
            role={Role.MENTOR}
          >
            <ViewCourseMentorPage />
          </PrivateRoute>
          <PrivateRoute exact path="/mentor/profile" role={Role.MENTOR}>
            <ProfilePage />
          </PrivateRoute>

          <PrivateRoute exact path="/mentor/sessions" role={Role.MENTOR}>
            <SessionsPage />
          </PrivateRoute>
          <PrivateRoute exact path="/mentor/create-session" role={Role.MENTOR}>
            <CreateSessionPage />
          </PrivateRoute>
          <PrivateRoute
            exact
            path="/mentor/edit-session/:session_Id"
            role={Role.MENTOR}
          >
            <EditSessionPage />
          </PrivateRoute>
          <PrivateRoute
            exact
            path="/mentor/session-requests"
            role={Role.MENTOR}
          >
            <SessionRequestsPage />
          </PrivateRoute>
          <PrivateRoute
            exact
            path="/mentor/zoom-session/:session_Id"
            role={Role.MENTOR}
          >
            <ZoomSession />
          </PrivateRoute>

          <Route exact path="/drmpoc">
            <DrmPoc />
          </Route>

          <Route exact path="">
            <NotFoundPage />
          </Route> */}
        </Switch>
      </BrowserRouter>
    </>
  );
}

export default App;
